import Category from "./categoryList.container";

export default Category